import * as d3 from 'd3';
import { RenderContext } from '../types';

const GRID_OPACITY = 0.3;

export function renderGridLines(ctx: RenderContext): void {
    const { g, scales, layout, theme } = ctx;

    // Vertical grid lines
    g.selectAll('.grid-line-vertical')
        .data(scales.x.ticks(10))
        .join('line')
        .attr('class', 'grid-line-vertical')
        .attr('x1', d => scales.x(d))
        .attr('x2', d => scales.x(d))
        .attr('y1', 0)
        .attr('y2', layout.priceHeight)
        .attr('stroke', theme.palette.divider)
        .attr('stroke-width', 0.5)
        .attr('stroke-dasharray', '2 2')
        .attr('stroke-opacity', GRID_OPACITY)
        .style('pointer-events', 'none');

    // Horizontal grid lines
    g.selectAll('.grid-line-horizontal')
        .data(scales.y.ticks(5))
        .join('line')
        .attr('class', 'grid-line-horizontal')
        .attr('x1', 0)
        .attr('x2', layout.innerWidth)
        .attr('y1', d => scales.y(d))
        .attr('y2', d => scales.y(d))
        .attr('stroke', theme.palette.divider)
        .attr('stroke-width', 0.5)
        .attr('stroke-dasharray', '2 2')
        .attr('stroke-opacity', GRID_OPACITY)
        .style('pointer-events', 'none');
}
